import { gql } from '@apollo/client';
export const REPORT_RUN_FIELDS = gql `
  fragment ReportRunFields on ReportRun {
    id
    createdAt
    updatedAt
    clientId
    reportTemplateId
    reportTemplateName
    totalRows
    s3Key
    startedAt
    completedAt
    status
    error
  }
`;
export const REPORT_RUNS = gql `
  ${REPORT_RUN_FIELDS}
  query REPORT_RUNS($spec: ReportRunSpec!) {
    reportRuns(spec: $spec) {
      total
      page
      pageSize
      items {
        ...ReportRunFields
      }
    }
  }
`;
export const DOWNLOAD_REPORT = gql `
  query DOWNLOAD_REPORT($id: Int!) {
    downloadReport(id: $id)
  }
`;
